import { combineReducers } from 'redux';

import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_DETAIL_CHANGED,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_FAILURE,
  UPDATE_LOAN_DETAIL_SUCCESS,
  UPDATE_LOAN_DETAIL_CALCULATOR,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from '../../actions/types'

import variable from './variable';
import fixed from './fixed';
import settings from './settings';
import interestType from './interestType';
import summary from './summary';
import calculator from './calculator';
import financialGraph from './financialGraph';

const errors = (state={}, {type, payload}) => {
  switch(type){
    case UPDATE_LOAN_DETAIL_FAILURE:
      return payload.loanDetail.errors
    default:
      return {}
  }
}

export const getInterest = (state, rateType) => state[rateType];
export const getFixedAmount = (state) => state.fixed.fixedAmount;
export const getFixedAmountError = (state) => state.errors.fixedAmount;
export const getSettings = (state) => state.settings;

export const getLoanSetupRate = (state, rateType) => {
  return state.calculator[rateType]
}

export const getLoanDetailParams = (state) => {
  const {
    interestType,
    variable,
    fixed,
    settings,
    calculator,
  } = state

  switch(state.interestType) {
    case 'variable':
      return {
        interestType,
        variable,
        fixed: {},
        settings,
        calculator,
      }
    case 'fixed':
      return {
        interestType,
        fixed,
        variable: {},
        settings,
        calculator,
      }
    case 'split':
    default:
      return state
  }
}

export default combineReducers({
  interestType,
  variable,
  fixed,
  settings,
  errors,
  summary,
  calculator,
  financialGraph,
});
